import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesheetComponent } from './timesheet.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    TimesheetComponent
  ],
  exports:[
    TimesheetComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class TimesheetModule { }
